import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { PATH_PANIER, PATH_ACCUEIL, PATH_FORMULAIRE_INSCRIPTION_INACTIVITE } from '../../constants/navigation-constants';
import './formulaire-confirmation-page.css';

const FormulaireConfirmationPage = (props) => {
  const history = useHistory();
  const location = useLocation();
  const idZec = props.match?.params?.idZec;
  const lang = props.match?.params?.language || 'fr';

  const isInactivite = location.pathname.includes(PATH_FORMULAIRE_INSCRIPTION_INACTIVITE);

  const t = isInactivite
    ? {
        title: lang === 'fr' ? 'Session expirée' : 'Session expired',
        message: lang === 'fr'
          ? 'Pour des raisons de sécurité, la page a été fermée après une période d\'inactivité. Vos informations ont été enregistrées.'
          : 'For security reasons, this page was closed after a period of inactivity. Your information was saved.',
        backToHome: lang === 'fr' ? "Retour à l'accueil" : 'Back to home'
      }
    : {
        title: lang === 'fr' ? 'Confirmation' : 'Confirmation',
        message: lang === 'fr'
          ? 'Vos informations ont été enregistrées avec succès.'
          : 'Your information has been successfully saved.',
        backToCart: lang === 'fr' ? 'Retour au panier' : 'Back to cart',
        backToHome: lang === 'fr' ? "Retour à l'accueil" : 'Back to home'
      };

  // const baseUri = `/${idZec || ''}/${lang}`;

  return (
    <div className="formulaire-confirmation-page">
      <div className="formulaire-confirmation-card">
        <h1 className="formulaire-confirmation-title">{t.title}</h1>
        <p className="formulaire-confirmation-message">{t.message}</p>
        <div className="formulaire-confirmation-actions">
          {/* {isInactivite && (
            <button
              type="button"
              className="formulaire-confirmation-button formulaire-confirmation-button-secondary"
              onClick={() => history.push({ pathname: `${baseUri}${PATH_ACCUEIL}` })}
            >
              {t.backToHome}
            </button>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default FormulaireConfirmationPage;